import AdminLayout from "@/components/Layout/Admin"
import { Link } from "@inertiajs/react"
import { ReactNode } from "react"

const Dashboard = ({ user_count, alert_count, pages, emails }) => (
  <div>
    <div className="flex text-center">
      <div className="mr-1 flex-1 rounded border-2 border-gray-900 bg-white p-4">
        <span className="text-4xl font-bold">{user_count}</span>
        <br />
        <span className="text-xs font-bold uppercase">Users</span>
      </div>
      <div className="ml-1 flex-1 rounded border-2 border-gray-900 bg-white p-4">
        <span className="text-4xl font-bold">{alert_count}</span>
        <br />
        <span className="text-xs font-bold uppercase">Alerts</span>
      </div>
    </div>

    <div className="mt-10 text-center">
      <h2 className="text-xl font-bold">Pages</h2>
      <ul className="leading-loose">
        {pages.map((page) => (
          <li key={page.id}>
            <Link href={`/admin/pages/${page.id}/edit`}>{page.name}</Link>
          </li>
        ))}
      </ul>
    </div>

    <div className="mt-10 text-center">
      <h2 className="text-xl font-bold">Emails</h2>
      <ul className="leading-loose">
        {emails.map((email) => (
          <li key={email.id}>
            <Link href={`/admin/emails/${email.id}/edit`}>{email.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  </div>
)

Dashboard.layout = (page: ReactNode) => <AdminLayout children={page} />

export default Dashboard
